import { defineMessages } from 'react-intl';

export default defineMessages({
  stepOneParagraphOne: {
    id: 'coachmarks.Search.Step.One.P1',
    defaultMessage:
      '<p>Before you start exploring schools, a few tips:<br />Use this menu bar to move through the application at your own pace. Just be sure to submit your application (Apply) before the deadline!</p>',
    description: 'Coachmarks search step one P1',
  },
  stepOneParagraphOnePK: {
    id: 'coachmarks.Search.Step.One.P1.PK',
    defaultMessage:
      '<p>Before you start exploring programs, a few tips:<br />Use this menu bar to move through the application at your own pace. Just be sure to submit your application (Apply) before the deadline!</p>',
    description: 'Coachmarks search step one P1 PK',
  },
  stepOneParagraphTwo: {
    id: 'coachmarks.Search.Step.One.P2',
    defaultMessage:
      'Return to Overview at any time to view your checklist and track your progress. Later steps are also available, but focus on Search for now!',
    description: 'Coachmarks search step one P2',
  },
  stepTwoParagraphOne: {
    id: 'coachmarks.Search.Step.Two.P1',
    defaultMessage:
      '<p>Before you start exploring schools, a few tips!</p>',
    description: 'Coachmarks search step two P1',
  },
  stepTwoParagraphOnePK: {
    id: 'coachmarks.Search.Step.Two.P1.PK',
    defaultMessage:
      '<p>Before you start exploring programs, a few tips!</p>',
    description: 'Coachmarks search step two P1 PK',
  },
  stepTwoParagraphOne3K: {
    id: 'coachmarks.Search.Step.Two.P1.3K',
    defaultMessage:
      '<p>Before you start exploring programs, a few tips!</p>',
    description: 'Coachmarks search step two P1 3K',
  },
  stepTwoParagraphOne2K: {
    id: 'coachmarks.Search.Step.Two.P1.2K',
    defaultMessage:
      '<p>Before you start exploring programs, a few tips!</p>',
    description: 'Coachmarks search step two P1 2-K',
  },
  stepTwoParagraphTwo: {
    id: 'coachmarks.Search.Step.Two.P2',
    defaultMessage:
      '<p>Students actually apply to programs at schools. Each school card also lists programs at that school.</p>',
    description: 'Coachmarks search step two P2',
  },
  stepTwoParagraphTwoEarlyChildhood: {
    id: 'coachmarks.Search.Step.Two.P2.EarlyChildhood',
    defaultMessage: '<p>Students apply to programs at each provider. Each provider lists the programs offered.</p>',
    description: 'Coachmarks search step two P2 for early childhood (2K, 3K, PK)',
  },
  stepTwoParagraphTwo3K: {
    id: 'coachmarks.Search.Step.Two.P2.3K',
    defaultMessage: '<p>Students apply to programs at each provider. Each provider lists the programs offered.</p>',
    description: 'Coachmarks search step two P2 for 3k',
  },
  stepTwoParagraphTwoPK: {
    id: 'coachmarks.Search.Step.Two.P2.PK',
    defaultMessage:
      '<p>Students actually apply to programs at each provider. Each provider lists the programs offered.</p>',
    description: 'Coachmarks search step two P2 PK',
  },
  stepThreeParagraphOne: {
    id: 'coachmarks.Search.Step.Three.P1',
    defaultMessage:
      '<p>Think of a program (like this one) as a doorway to get into the school. Tap or click on programs to learn about them.</p>',
    description: 'Coachmarks search step three P1',
  },
  stepThreeParagraphOnePK: {
    id: 'coachmarks.Search.Step.Three.P1.PK',
    defaultMessage:
      '<p>Think of a program (like this one) as a doorway to the location. Tap or click on programs to learn about them.</p>',
    description: 'Coachmarks search step three P1 PK',
  },
  stepThreeParagraphTwo: {
    id: 'coachmarks.Search.Step.Three.P2',
    defaultMessage:
      '<p>You can apply to multiple programs at a school, if you’re interested in more than one. Some schools have programs that focus on certain interests or areas of study, and some schools have programs that reflect the whole school’s offerings.</p>',
    description: 'Coachmarks search step three P2',
  },
  stepThreeParagraphTwoPK: {
    id: 'coachmarks.Search.Step.Three.P2.PK',
    defaultMessage:
      '<p>You can apply to multiple programs offered by a single provider, if you’re interested in more than one.</p>',
    description: 'Coachmarks search step three P2 PK',
  },
  stepThreeParagraphTwoKindergarten: {
    id: 'coachmarks.Search.Step.Three.P2.Kindergarten',
    defaultMessage: '<p>You can apply to multiple programs at a school, if you’re interested in more than one.</p>',
    description: 'Coachmarks search step three P2 Kindergarten',
  },
  stepFourParagraphOne: {
    id: 'coachmarks.Search.Step.Four.ParagraphOne',
    defaultMessage: '<p>How to decide? There are a lot of programs, and a lot of information about each.</p>',
    description: 'Coachmarks search step four paragraph one',
  },
  stepFourParagraphTwo: {
    id: 'coachmarks.Search.Step.Four.ParagraphTwo',
    defaultMessage:
      '<p>Many families consider the daily commute and the school’s location to be important factors. Use the map to see a school’s location and the distance from your child’s home.</p>',
    description: 'Coachmarks search step four paragraph two',
  },
  stepFourParagraphTwoPK: {
    id: 'coachmarks.Search.Step.Four.ParagraphTwo.PK',
    defaultMessage:
      '<p>Many families consider the daily commute and the program’s location to be important factors. Use the map to see a program’s location and the distance from your child’s home.</p>',
    description: 'Coachmarks search step four paragraph two PK',
  },
  stepFiveParagraphOne: {
    id: 'coachmarks.Search.Step.Five.ParagraphOne',
    defaultMessage:
      '<p>How to decide? Use the filters below the search bar to see only schools that meet certain criteria. From More Filters, select the Eligible filter to only see schools you can list on your application!</p>',
    description: 'Coachmarks search step five paragraph one',
  },
  stepFiveParagraphOnePK: {
    id: 'coachmarks.Search.Step.Five.ParagraphOne.PK',
    defaultMessage: '<p>Use the filters below the search bar to see only programs that meet certain criteria.</p>',
    description: 'Coachmarks search step five paragraph one PK',
  },
  stepFiveParagraphOneMiddleSchool: {
    id: 'coachmarks.Search.Step.Five.ParagraphOne.middleschool',
    defaultMessage:
      '<p>How to decide? Use the filters below the search bar to see only schools that meet certain criteria.</p>',
    description: 'Coachmarks search step five paragraph one for Middle School',
  },
  stepFiveParagraphTwo: {
    id: 'coachmarks.Search.Step.Five.ParagraphTwo',
    defaultMessage: '<p>Find information on criteria like academic performance, sports, and activities.</p>',
    description: 'Coachmarks search step five paragraph two',
  },
  stepFiveParagraphTwoPK: {
    id: 'coachmarks.Search.Step.Five.ParagraphTwo.PK',
    defaultMessage:
      '<p>Find information on criteria like extended day and language supports offered by selecting programs.</p>',
    description: 'Coachmarks search step five paragraph two PK',
  },
  stepFiveParagraphTwoKindergarten: {
    id: 'coachmarks.Search.Step.Five.ParagraphTwo.Kindergarten',
    defaultMessage:
      '<p>Find information on criteria like academic performance and size by selecting a school or programs.</p>',
    description: 'Coachmarks search step five paragraph two Kindergarten',
  },
  stepSix: {
    id: 'coachmarks.Search.Step.Six',
    defaultMessage:
      '<p>When you find a program you like, click the star to add it to your favorites.</p><p>You can view your list of your favorite programs on the apply page.</p>',
    description: 'Coachmarks search step six',
  },
  stepSixParagraphOne: {
    id: 'coachmarks.Search.Step.Six.ParagraphOne',
    defaultMessage: '<p>When you find a program you like, click the star to add it to your favorites.</p>',
    description: 'Coachmarks search step six',
  },
  stepSixParagraphTwo: {
    id: 'coachmarks.Search.Step.Six.ParagraphTwo',
    defaultMessage: '<p>You can view a list of your favorite programs on the apply page.</p>',
    description: 'Coachmarks search step six',
  },
  stepSixParagraphOne3k: {
    id: 'coachmarks.Search.Step.Six.ParagraphOne3k',
    defaultMessage:
      '<p>When you find a program you’re interested in, click the star to add it to your favorites. You can view a list of your favorite programs on the apply page.</p>',
    description: 'Coachmarks search step six for 3k',
  },
  stepSeven: {
    id: 'coachmarks.Search.Step.Seven',
    defaultMessage:
      'Want to better understand your child’s chances of getting an offer to each program? Hover or tap these icons to learn about the program’s demand and find out your child’s priority group. These icons will not display if your child is not eligible for the program, or if the program is their guaranteed program. Click or tap on the program for more details.',
    description: 'Coachmarks search step seven',
  },
  stepSevenParagraphOnePK: {
    id: 'coachmarks.Search.Step.Seven.ParagraphOne.PK',
    defaultMessage:
      '<p>Click or tap on the program for more details.</p>',
    description: 'Coachmarks search step six',
  },
  stepSevenMiddleSchool: {
    id: 'coachmarks.Search.Step.Seven.middleschool',
    defaultMessage:
      'Hover or tap these icons to learn about the program’s demand and find out your child’s priority group. Click or tap on the program for more details.',
    description: 'Coachmarks search step seven for Middle School',
  },
  stepSevenKindergarten: {
    id: 'coachmarks.Search.Step.Seven.Kindergarten',
    defaultMessage:
      'Click or tap on the program for more details.',
    description: 'Coachmarks search step seven for Kindergarten',
  },
  stepEight: {
    id: 'coachmarks.Search.Step.Eight',
    defaultMessage:
      'You’re ready to start exploring programs!',
    description: 'Coachmarks search step eight',
  },
});
